module.exports = __webpack_public_path__ + "img/lat-tilt-warning.988cbc35.png";